/*Generated from the `:::slide{key="c43f4eac-4de2-45c4-b133-465dd59a9234" slug="level-1/after-非/pronunciation"}` (simplified/018/001/非.mdx) directive. Edit the lesson or level file.*/
import {useMDXComponents} from "@bacons/mdx";
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
function _createMdxContent(props) {
  const components = {
    ...useMDXComponents(),
    ...props.components
  };
  const {SlidePageBlock, SlideTitle, ...html} = components;
  if (!SlidePageBlock) _missingMdxReference("SlidePageBlock", true);
  if (!SlideTitle) _missingMdxReference("SlideTitle", true);
  if (!html) _missingMdxReference("html", false);
  if (!html.p) _missingMdxReference("html.p", true);
  return _jsxs(_Fragment, {
    children: [_jsx(SlidePageBlock, {
      block: "0",
      section: "0",
      kind: "SlideTitle",
      count: "4",
      children: _jsx(SlideTitle, {
        children: "Pronunciation",
        components: html
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "1",
      section: "0",
      kind: "p",
      count: "4",
      children: _jsx(html.p, {
        children: "In addition to helping you remember the meanings of characters, Haniverse has (optional) mnemonics that help you remember their pronunciations as well!",
        components: html
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "2",
      section: "0",
      kind: "p",
      count: "4",
      children: _jsx(html.p, {
        children: "Haniverse assigns an English word to each possible pinyin and combines it with the color representing the tone to create a visual object to be associated with the character.",
        components: html
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "3",
      section: "0",
      kind: "p",
      keepWithNext: "true",
      count: "4",
      children: _jsx(html.p, {
        children: "For example:",
        components: html
      }),
      components: html
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
